const BASE = '/api';

export interface AppConfig {
  nome_loja: string;
  partida_endereco: string;
  partida_lat: string;
  partida_lng: string;
  pedido_minimo: string;
  horario_entrega: string;
  horario_corte: string;
  dias_funcionamento: string;
  numero_operador: string;
  tema_accent: string;
}

async function jsonReq<T>(path: string, init?: RequestInit): Promise<T> {
  const r = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...init,
  });
  const body = await r.json().catch(() => ({}));
  if (r.status === 401) window.dispatchEvent(new CustomEvent('auth:expirou'));
  if (!r.ok) throw new Error((body as { erro?: string })?.erro || `HTTP ${r.status}`);
  return body as T;
}

export async function buscarConfigCompleta(): Promise<AppConfig> {
  const r = await jsonReq<{ ok: boolean; config: AppConfig }>(`/config`);
  return r.config;
}

export async function salvarConfig(
  patch: Partial<AppConfig>,
): Promise<{ config: AppConfig; geocodificado?: boolean }> {
  const r = await jsonReq<{ ok: boolean; config: AppConfig; geocodificado?: boolean }>(`/config`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  return { config: r.config, geocodificado: r.geocodificado };
}
